
import Vue from 'vue';
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';

export default Vue.extend({
  name: 'spinner',

  data() {
    return {
      scrollY: '0',
      key: 0,
    };
  },

  components: {
    ClipLoader,
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  },

  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll() {
      this.scrollY = `${window.scrollY}px`;
      this.key++;
    },
  },
});
